import { Route, Routes } from 'react-router-dom';
import { ROLE } from '../../Constant';
import { PrivateRoute } from '../components/PrivateRoute';
import { List } from './List';

export default function Invoice() {

  return (
    <Routes>
      <Route path="/don-hang/*" element={<List />} />
    </Routes>
  );
}
